module.exports = __webpack_public_path__ + "static/NetworkPlus-e878e98ca484a4b40fa994711e09a9f1.png";